import React from 'react';
import { Header, Table } from 'semantic-ui-react';

import { escribirMonto } from '../../utilidades';

interface TablaTotalPagosPorAreaProps {
    totalEfectivo: number;
    totalTarjetaDebito: number;
    totalTarjetaCredito: number;
    totalDeposito: number;
    totalTransferencia: number;
    totalCheque: number;
    totalEfectivoMenosGastosDiarios: number;
}

const TablaTotalMetodoDePago: React.FunctionComponent<TablaTotalPagosPorAreaProps> = props => {
    const {
        totalEfectivo,
        totalTarjetaDebito,
        totalTarjetaCredito,
        totalDeposito,
        totalTransferencia,
        totalCheque,
        totalEfectivoMenosGastosDiarios,
    } = props;
    return (
        <div>
            <Header as='h4'>Ingreso total de cada forma de pago</Header>
            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={12}>Forma de pago</Table.HeaderCell>
                        <Table.HeaderCell width={4}>Monto</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>Efectivo</Table.Cell>
                        <Table.Cell>{escribirMonto(totalEfectivo)}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Tarjeta de débito</Table.Cell>
                        <Table.Cell>{escribirMonto(totalTarjetaDebito)}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Tarjeta de crédito</Table.Cell>
                        <Table.Cell>{escribirMonto(totalTarjetaCredito)}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Depósito</Table.Cell>
                        <Table.Cell>{escribirMonto(totalDeposito)}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Transferencia</Table.Cell>
                        <Table.Cell>{escribirMonto(totalTransferencia)}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>Cheque</Table.Cell>
                        <Table.Cell>{escribirMonto(totalCheque)}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
            <Table celled>
                <Table.Header />
                <Table.Body>
                    <Table.Row>
                        <Table.Cell width={12}>Efectivo total del día</Table.Cell>
                        <Table.Cell width={4}>
                            {escribirMonto(totalEfectivoMenosGastosDiarios)}
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        </div>
    );
};

export default TablaTotalMetodoDePago;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Informes/Componentes/TablaTotalMetodoDePago.tsx